import _ from "lodash";

import { GlobalHelper } from "@/shared/shared";
import { IUserProfile } from "@/shared/user";

import { initialState, IState } from "../state";

export class Auth {
  static login(state: IState, user: IUserProfile) {
    const newState = Object.assign({}, state);

    // Sort assets by name
    user.assets.modules = GlobalHelper.sortModules(user.assets.modules);
    user.assets.vessels = GlobalHelper.sortVessels(user.assets.vessels);

    newState.isLoggedIn = true;
    newState.user = user;
    newState.loginTimestamp = +new Date();
    return newState;
  }

  static logout(state: IState) {
    const newState = Object.assign({}, state);

    newState.isLoggedIn = false;
    newState.user = _.cloneDeep(initialState.user);
    return newState;
  }

  static didShowWelcome(state: IState) {
    const newState = Object.assign({}, state);
    debugger;
    newState.didShowWelcome = true;
    return newState;
  }
}
